<div class="tank-consumption relative p-4">
  <div class="reorder">
    <re-reorder-buttons (reorder)="onReorder($event)" />
  </div>

  <div class="delete absolute top-3 right-3">
    <re-trash-button (delete)="onDelete()" />
  </div>

  <h2 class="transfer-header text-center">Consumption</h2>
  <div class="container">
    <div class="tank">
      <re-tank-summary
        [tank]="from"
        [progress]="fromProgress"
        [progress2]="progress2"
        [tankNumber]="1"
        [tankName]="'HFO (L)'"
        [fuelGrade]="'HFO'"
        [quantity]="from.content!.quantity - totalConsumeAmount"
      />
    </div>

    <div class="main-engine mb-4">
      <label for="main_engine_consumption">Main Engine</label>
      <input
        (input)="onInputChange()"
        (ngModelChange)="onModelChange()"
        [(ngModel)]="mainEngineConsumption"
        [min]="0"
        [max]="maxConsumeAmount"
        type="number"
        id="main_engine_consumption"
        name="main-engine-amount"
        placeholder="0"
        class="mx-2 border-1 px-2"
      />
      MT
    </div>

    <div class="aux-engine mb-4">
      <div class="form-group">
        <label for="aux_engine_consumption">Aux Engine</label>
        <input
          [ngModel]="totalAuxEngineConsumptions"
          (ngModelChange)="onModelChange()"
          type="number"
          name="aux-engine-amount"
          placeholder="0"
          readonly
          class="mx-2 border-1 px-2"
          id="aux_engine_consumption"
        />
        MT
      </div>

      <div class="form-group">
        <label for="ballast_operations_consumption">Ballast Operations</label>
        <input
          (input)="onInputChange()"
          (ngModelChange)="onModelChange()"
          [(ngModel)]="auxEngineConsumptions.ballastOperations"
          [min]="0"
          [max]="maxConsumeAmount"
          type="number"
          name="main-engine-amount"
          placeholder="0"
          class="mx-2 border-1 px-2"
          id="ballast_operations_consumption"
        />
        MT
      </div>

      <div class="form-group">
        <label for="cargo_heating_consumption">Cargo Heating</label>
        <input
          (input)="onInputChange()"
          (ngModelChange)="onModelChange()"
          [(ngModel)]="auxEngineConsumptions.cargoHeating"
          [min]="0"
          [max]="maxConsumeAmount"
          type="number"
          name="main-engine-amount"
          placeholder="0"
          class="mx-2 border-1 px-2"
          id="cargo_heating_consumption"
        />
        MT
      </div>

      <div class="form-group">
        <label for="tank_cleaning_consumption">Tank Cleaning</label>
        <input
          (input)="onInputChange()"
          (ngModelChange)="onModelChange()"
          [(ngModel)]="auxEngineConsumptions.tankCleaning"
          [min]="0"
          [max]="maxConsumeAmount"
          type="number"
          name="main-engine-amount"
          placeholder="0"
          class="mx-2 border-1 px-2"
          id="tank_cleaning_consumption"
        />
        MT
      </div>

      <div class="form-group">
        <label for="cargo_discharging_consumption">Cargo Discharging</label>
        <input
          (input)="onInputChange()"
          (ngModelChange)="onModelChange()"
          [(ngModel)]="auxEngineConsumptions.cargoDischarging"
          [min]="0"
          [max]="maxConsumeAmount"
          type="number"
          name="main-engine-amount"
          placeholder="0"
          class="mx-2 border-1 px-2"
          id="cargo_discharging_consumption"
        />
        MT
      </div>

      <div class="form-group">
        <label for="bunker_heating_consumption">Bunker Heating</label>
        <input
          (input)="onInputChange()"
          (ngModelChange)="onModelChange()"
          [(ngModel)]="auxEngineConsumptions.bunkerHeating"
          [min]="0"
          [max]="maxConsumeAmount"
          type="number"
          name="main-engine-amount"
          placeholder="0"
          class="mx-2 border-1 px-2"
          id="bunker_heating_consumption"
        />
        MT
      </div>
    </div>

    <div>
      <div class="form-group {{ !isValid ? 'text-red-500' : '' }}">
        <label for="total_consumption">Total: </label>
        <input
          [ngModel]="totalConsumeAmount"
          (ngModelChange)="onModelChange()"
          type="number"
          name="aux-engine-amount"
          placeholder="0"
          readonly
          class="mx-2 border-1 px-2"
          id="total_consumption"
        />
        MT

        @if (!isValid) {
          <div class="mt-2">Total must not exceed tank contents.</div>
        }
      </div>
    </div>
  </div>
</div>
